import React from 'react';
import { useKeenSlider } from 'keen-slider/react';
import 'keen-slider/keen-slider.min.css';
import Image from '../Image';
import { ImageWrapper } from './ImageSlider.styles';

const animation = { duration: 50000, easing: t => t };

const ImageSlider = ({ items }) => {
  const [sliderRef] = useKeenSlider({
    loop: true,
    renderMode: 'performance',
    drag: true,
    slides: {
      spacing: 30,
      perView: 'auto',
    },
    breakpoints: {
      '(min-width: 769px)': {
        slides: {
          spacing: 60,
          perView: 'auto',
        },
      },
    },
    created(s) {
      s.moveToIdx(5, true, animation);
    },
    updated(s) {
      s.moveToIdx(s.track.details.abs + 5, true, animation);
    },
    animationEnded(s) {
      s.moveToIdx(s.track.details.abs + 5, true, animation);
    },
  });
  return (
    <div ref={sliderRef} className="keen-slider">
      {items &&
        items.map(item => (
          <ImageWrapper key={item?.id} className={`keen-slider__slide `}>
            <Image image={item} />
          </ImageWrapper>
        ))}
    </div>
  );
};

export default ImageSlider;
